module.exports = __webpack_public_path__ + "images/placeholder-8560b8a2.png";